import { defineNuxtRouteMiddleware } from '#app/composables/router';
import { useAccountReturnRouteState } from '~/composables/use-account-return-route-state';
import { isAccountRoute, isGuestOrPublicRoute } from '~/utils/routes';

export default defineNuxtRouteMiddleware((to, from) => {
	if (isGuestOrPublicRoute(to)) return;

	const returnRoute = useAccountReturnRouteState();

	if (isAccountRoute(to.path) && !isAccountRoute(from.path) && from.path !== '/') {
		returnRoute.value = from.fullPath;
	}

	if (!isAccountRoute(to.path) && isAccountRoute(from.path)) {
		returnRoute.value = null;
	}
});
